import { IssueTypeFieldValuesService as OvermapIssueTypeFieldValuesService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import { FIELD_VALUES_PAGINATION_PAGE_SIZE } from "../constants"
import type { AppSDK } from "../sdk"

export class IssueTypeFieldValuesService extends OvermapIssueTypeFieldValuesService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
	pageSize = FIELD_VALUES_PAGINATION_PAGE_SIZE
}
